const en = {
    language: {
        label: 'Language',
        heading: 'Display language',
        help: 'Choose the language for menus, buttons, labels, Help, and report headers in BistroAdmin. This is only for this browser and does not change POS, the Payroll app, customer messages, money format, or merchant times.',
        posHeading: 'POS display language',
        posHelp: 'This language is used on all POS terminals for this store. It is separate from the BistroAdmin language above. Unset or unknown values use English. Changing it does not block login, clock-in, or sales.',
        posLabel: 'POS language',
        posSave: 'Save POS language',
    },
    common: {
        cancel: 'Cancel',
        save: 'Save',
        saving: 'Saving…',
        refresh: 'Refresh data',
        loading: 'Loading…',
        add: 'Add New',
        edit: 'Edit',
        delete: 'Delete',
        open: 'Open',
        yes: 'Yes',
        no: 'No',
        confirm: 'Are you sure?',
        name: 'Name',
        status: 'Status',
        actions: 'Actions',
        action: 'Action',
        image: 'Image',
        active: 'Active',
        archived: 'Archived',
        default: 'Default',
        connected: 'Connected',
        notConnected: 'Not connected',
        required: 'Required',
        optional: 'Optional',
        update: 'Update',
    },
    nav: {
        products: 'Products',
        workPeriods: 'Work Periods',
        users: 'Users',
        settings: 'Settings',
        help: 'Help',
        logOut: 'Log Out',
        toggle: 'Toggle navigation',
        logoAlt: 'Bistro Admin',
    },
    header: {
        refreshToast: 'Refreshing data...',
        merchantUnavailable: 'Merchant information is unavailable.',
    },
    login: {
        title: 'Login to your Account',
        username: 'Username',
        usernamePlaceholder: 'Enter Username',
        password: 'Password',
        passwordPlaceholder: 'Enter password',
        submit: 'Login',
        submitting: 'Logging in…',
        logoAlt: 'Bistro Admin',
    },
    settingsTabs: {
        store: 'Store',
        stations: 'Stations',
        customerScreen: 'Customer Screen',
        layouts: 'Layouts',
        integrations: 'Integrations',
        system: 'System',
        payroll: 'Payroll',
        payout: 'Payout',
    },
    productsTabs: {
        categories: 'Categories',
        products: 'Products',
        menus: 'Menus',
        export: 'Export',
        import: 'Import',
        exportTitle: 'Export all products & categories',
        importTitle: 'Import products and categories from file',
        merchantUnavailable: 'Merchant information is unavailable. Try refreshing the page or logging in again.',
        exportFormat: 'Export Format',
        exportChoose: 'Choose a format to export your products and categories:',
        importFormat: 'Import Format',
        importChoose: 'Choose the format of the file you want to import:',
        excel: 'Excel (.xlsx)',
        json: 'JSON (.json)',
        confirmImport: 'Confirm Import',
        aboutToImport: 'You are about to import:',
        categoriesCount: '{count} categories',
        productsCount: '{count} products',
        variationsCount: '{count} variations',
        optionsCount: '{count} options',
        importNote: 'Categories that already exist will be skipped. Products will be created as new items.',
        exportedOn: 'Exported on: {date}',
        importing: 'Importing Products...',
        categoriesTitle: 'Categories',
        categoryName: 'Category Name',
        items: 'Items',
        printer: 'Printer',
        addCategory: 'Add Category',
        editCategory: 'Edit Category',
        changeImage: 'Change',
        addIcon: 'Add Icon',
        productsTitle: 'Products',
        product: 'Product',
        category: 'Category',
        variationsShort: 'Var.',
        priceUsd: 'Price($)',
        inStock: 'In Stock',
        sku: 'SKU',
        menusTitle: 'Menus',
        menusIntro: 'Named menus filter the POS catalog. Import/export does not include menus. Default for all stations: {default} (stations can override under Settings → Stations).',
        menusIntroSchedule: ' Open a menu to edit its schedule windows.',
        showArchived: 'Show archived',
        autoScheduleOn: 'Auto schedule on',
        useAutoSchedule: 'Use Auto schedule',
        autoScheduleTitle: 'Turn Auto schedule on. Matching windows override the default. When no window matches, POS uses the selected default (or All if none). Click again to turn Auto off.',
        autoScheduleOnTitle: 'Turn Auto schedule off. The selected default menu stays.',
        autoScheduleWithFallback: 'Auto schedule (when no window: {default})',
        clearDefault: 'Clear default (All)',
        addMenu: 'Add Menu',
        noMenus: 'No menus yet. Create Breakfast / Lunch / Dinner to filter the POS catalog. Until then, POS shows the full catalog.',
        menuNameRequired: 'Menu name is required.',
        order: 'Order',
        autoSchedule: 'Auto schedule',
        allFullCatalog: 'All (full catalog)',
        editMenu: 'Edit Menu',
        sortOrder: 'Sort order',
        moveUp: 'Move up',
        moveDown: 'Move down',
        setDefault: 'Set default',
        setDefaultTitle: 'Stations without an override load this menu. With Auto on, this is also used when no window matches.',
        archive: 'Archive',
        restore: 'Restore',
        internal: 'Internal',
        fromCategory: 'From category',
    },
    usersChrome: {
        people: 'People',
        name: 'Name',
        phone: 'Phone Number',
        email: 'Email Address',
        roleType: 'Role type',
        role: 'Role',
        stripeTips: 'Stripe Tip Payouts',
        addPeople: 'Add People',
        editPeople: 'Edit People',
        id: 'ID',
        phoneShort: 'Phone',
        created: 'Created',
        tips: 'Tips',
        pin: '4 Digit Pin Number',
        pinHelp: '4 digits, cannot start with 0',
        pinPlaceholder: 'e.g. 1234',
        payroll: 'Payroll',
        receivesHourlyWage: 'Receives hourly wage',
        hourlyRate: 'Hourly rate',
        hourlyRequired: 'Required when hourly wage is enabled.',
        nonHourlyHelp: 'Non-hourly staff are excluded from wage-hours payroll sync.',
        tipsInPayroll: 'Tips & gratuity in payroll',
        inheritDefault: 'Use merchant default',
        alwaysInclude: 'Always include (unpaid tips & gratuity)',
        neverInclude: 'Never include',
        merchantDefaultHelp: 'Merchant default is set under Settings → Payroll.',
        stripeDisabled: 'Tip payouts are disabled in Store Settings. No employee Stripe setup links are available for this store.',
        stripeAfterCreate: 'After creating this user, you can either send a Stripe onboarding link to create a new account or link an existing Stripe account.',
    },
    workperiods: {
        end: 'End Work Period',
        ending: 'Ending...',
        start: 'Start Work Period',
        starting: 'Starting...',
        period: 'Period',
        trans: 'Trns.',
        charges: '*NET',
        net: 'CARD NET',
        fees: 'Fees',
        adminFees: 'Admin Fees',
        items: 'Items',
        card: 'Card',
        cash: 'Cash',
        tipsCard: 'Tips(Card)',
        tipOuts: 'Tip Outs',
        ref: 'Ref.',
        netSalesMerch: 'Sales after Refunds',
        tax: 'Tax',
        grat: 'Grat.',
        startDate: 'Start Date',
        endDate: 'End Date',
        active: 'Active',
        search: 'Search',
        searchPlaceholder: 'Period (e.g. Mon) or amount...',
    },
    payroll: {
        heading: 'Payroll',
        intro: 'Configure how this merchant prepares staff for payroll. Hourly wage and per-employee tip overrides are set on each person under Users. Finalizing a payrun in Rebelity Payroll can mark unpaid tips as paid (no Stripe transfer). When Check payroll is enabled, unpaid tips are marked paid only after Check wage ACH succeeds.',
        loading: 'Loading payroll settings…',
        enable: 'Enable payroll for this merchant',
        includeTips: 'Include tips & gratuity in payroll (merchant default)',
        engine: 'Payroll Engine',
        engineFallback: 'Enter the private Payroll Engine Base URL, then save.',
        baseUrl: 'Payroll Engine base URL',
        apiKey: 'API key (optional)',
        keySaved: 'Key saved — leave blank to keep',
        engineHelp: 'Browser never calls Payroll Engine. POSApi uses this URL to sync hours/tips and run PE tax tables. Use a host the API server can reach (not your laptop localhost on shared EB).',
        connecting: 'Connecting…',
        saveTest: 'Save & test connection',
        openPayroll: 'Open Payroll',
        save: 'Save payroll settings',
        checkPayroll: 'Check payroll',
        loadingCheck: 'Loading Check status…',
        manageIntegrations: 'Manage on Integrations',
        integrations: 'Integrations',
        payrollStates: 'Payroll states',
        taxHeading: 'Stripe Tax (sales tax) · Phase 5a',
        taxIntro: 'Merchant-liable sales tax via Stripe Tax for platforms (Atlanta / GA pilot address defaults). This is separate from payroll employment taxes. Register locations in the Stripe Dashboard for the connected account.',
        saveTax: 'Save Stripe Tax settings',
        recording: 'Recording…',
        recordRemit: 'Record remittance',
        offlineTaxMode: 'Offline / cash tax mode (T2)',
        taxApiDefault: 'Tax API + Tax Transactions (default)',
        stripeChannelsOnly: 'Stripe channels only (no cash Tax Transactions)',
    },
    report: {
        employeeSalesTitle: 'Employee Sales Report',
        workPeriodTitle: 'Work Period Sales Report',
        workPeriodDetail: 'Work Period Detail',
        employee: 'Employee',
        store: 'Store',
        period: 'Period',
        generated: 'Generated',
        summary: 'Summary',
        value: 'Value',
        shifts: 'Shifts',
        hours: 'Hours',
        totalSales: 'Total Sales',
        tips: 'Tips',
        gratuity: 'Gratuity',
        earnings: 'Earnings',
        cash: 'Cash',
        card: 'Card',
        member: 'Member',
        fees: 'Fees',
        tipsOwed: 'Tips Owed',
        tipsPaid: 'Tips Paid',
        totalTipsAndGrat: 'Total Tips & Grat.',
        yourShare: 'Your Share',
        pooledWorkPeriods: 'Pooled work periods',
        saleTimeWorkPeriods: 'Sale-time work periods',
        totalTipsGratExplainer: 'Total Tips & Grat. is the total tips and gratuity for the work period for all employees.',
        payoutExplainer: 'If you have not connected your bank account to our system through Stripe, you cannot be paid directly. Instead our tips will be sent to the designated shift manager and they must pay you. All weekend payouts are available the following Wednesday or Thursday.',
        overview: 'Overview',
        salesBreakdown: 'Sales breakdown',
        tipPayouts: 'Tip payouts',
        summaryFor: 'Summary for {range}',
        noShiftsIn: 'No shifts in {range}',
        date: 'Date',
        status: 'Status',
        clockIn: 'Clock In',
        clockOut: 'Clock Out',
        field: 'Field',
        time: 'Time',
        sales: 'Sales',
        tipsEarnings: 'Tips & Earnings',
        payoutStatus: 'Payout Status',
        totalHours: 'Total Hours',
        cashSales: 'Cash Sales',
        cardSales: 'Card Sales',
        memberSales: 'Member Sales',
        totalEarnings: 'Total Earnings',
        shift: 'Shift',
        sheetSummary: 'Summary',
        sheetWorkPeriods: 'Work Periods',
        none: 'None',
        stillActive: 'Still Active',
        employeeSalesHeading: '{name} Sales',
        employeeSalesSubtitle: 'View sales, tips, and work hours',
        export: 'Export',
        exporting: 'Exporting…',
        exportTitle: 'Export filtered report',
        emailPdf: 'Email PDF to {email}',
        noEmail: 'No email on file',
        textPdf: 'Text PDF link to {phone}',
        noPhone: 'No phone on file',
        pdf: 'PDF (.pdf)',
        csv: 'CSV (.csv)',
        excel: 'Excel (.xlsx)',
        paid: 'Paid',
        pending: 'Pending',
        transferId: 'Transfer ID',
        hrs: 'hrs',
        afterRefunds: 'After refunds',
        salesBeforeRefunds: 'Sales Before Refunds',
        salesAfterRefunds: 'Sales after Refunds',
        discounts: 'Discounts',
        comps: 'Comps',
        merchRefunds: 'Merchandise refunds',
        merchRefundsHelp: 'Merchandise refunds are the item cost only (food and drink returned). They do not include tax, fees, tips, or gratuity.',
        netSalesMerch: 'Sales after Refunds',
        customerRefunds: 'Customer refunds (charge)',
        customerRefundsHelp: 'Customer refunds are the full charge returned to the guest — merchandise plus any reversed tax, fees, tips, gratuity, and similar amounts.',
        taxCollected: 'Tax collected',
        taxRefunded: 'Tax refunded',
        taxNet: 'Tax net',
        taxNetHelp: 'Tax net = tax collected − tax refunded. Tax is not included in Sales Before Refunds or Sales after Refunds.',
        netTips: 'Net tips',
        netGratuity: 'Net gratuity',
        refundNetFootnote: 'Sales after Refunds = Sales Before Refunds − merchandise refunds. Customer charge refunds (tax, tip, fee) are listed separately and are not subtracted again from sales after refunds.',
        refundEstimateFootnote: 'Some refunds were amount-only (no item quantities). Merchandise and tip/grat refund shares are estimated — confirm against the POS refund receipt if needed.',
    },
    store: {
        details: 'Store Details',
        wpStart: 'Work Period Start Time',
        wpEnd: 'Work Period End Time',
        wpEndHelp: 'When set, open work periods end at this store-local time. Staff on POS get 15/5/1‑minute warnings with sound; auto-end waits until all open tabs are closed.',
        name: 'Store Name',
        type: 'Store Type',
        email: 'Email',
        phone: 'Phone No.',
        address: 'Address',
        useAccountDefault: 'Use Account default',
        street: 'Street',
        city: 'City',
        state: 'State',
        zip: 'Zip',
        description: 'Store Description',
        descriptionPlaceholder: 'Please enter a brief description of your store',
        receiptFooter: 'Receipt Footer text',
        receiptFooterHelp: 'This text will appear at the bottom of printed receipts',
        tipPayoutRouting: 'Tip Payout Routing',
        tipModeMerchant: 'Tips go to merchant — employees are paid by other means',
        tipModeDisabled: 'Tip payouts are disabled — no employee Stripe setup links or transfers will be used',
        tipModePlatform: 'Tips retained on platform — auto-transferred to employees via Stripe',
        tipRoutingMode: 'Tip Routing Mode',
        optionPlatform: 'Platform (Auto-transfer to employees)',
        optionMerchant: 'Merchant Account (Merchant pays employees)',
        optionDisable: 'Disable Tip Payout',
        saveDetails: 'Save Store Details',
        image: 'Store Image',
        imageDefault: '*Defaults to Client Account image if not specified',
        change: 'Change',
        addImage: 'Add Image',
        saveImage: 'Save Store Image',
        storeAlt: 'Store',
    },
    stations: {
        heading: 'Station:',
        intro: 'Create Stations to assign to Terminals',
        name: 'Station Name',
        namePlaceholder: 'Server Station',
        terminal: 'Terminal',
        unassigned: 'Unassigned',
        save: 'Save Station',
        note: 'Note:',
        noteBody: 'Terminals can only be assigned to Stations in BistroPOS. Once a Station is created here, you must assign a Terminal by navigating to the Settings menu then Terminals Tab in the Bistro Application.',
        available: 'Available Stations',
        menu: 'Menu',
        deleteConfirm: 'Delete station?',
        editName: 'Edit Station Name',
        inherit: 'Inherit merchant default',
        autoSchedule: 'Auto schedule',
        allCatalog: 'All (full catalog)',
        menuHelp: 'Overrides apply on Bistro / kiosk for this station. Cashiers can still switch menus until logout. Auto uses each menu’s schedule windows (merchant local time).',
        layout: 'Layout',
        layoutHelp: 'When Layout Mode is on, this station opens the selected floor plan. Any active layout for the account venue can be chosen.',
    },
    excel: {
        sheetCategories: 'Categories',
        sheetProducts: 'Products',
        name: 'Name',
        printerId: 'PrinterId',
        picture: 'Picture',
        internalOnly: 'InternalOnly',
        categoryName: 'CategoryName',
        description: 'Description',
        sku: 'SKU',
        barcode: 'Barcode',
        price: 'Price',
        feeOption: 'FeeOption',
        taxRate: 'TaxRate',
        inventory: 'Inventory',
        variations: 'Variations',
        options: 'Options',
        missingCategories: 'Missing "Categories" sheet in workbook',
        missingProducts: 'Missing "Products" sheet in workbook',
    },
    system: {
        loadFailed: 'Failed to load system settings.',
        notificationLoadFailed: 'Failed to load customer notification settings.',
        loadingSettings: 'Loading system settings…',
        loadingNotifications: 'Loading customer notification defaults…',
        deliveryHeading: 'Auto shift report delivery',
        deliveryIntro: 'When enabled, employees receive their work period sales report automatically when they clock out on the POS, or when an ended work period auto-clocks them out. Manual sends from Employee Sales are unchanged.',
        smsToggle: 'Send shift report by SMS on clock-out',
        smsHelp: 'Sends a PDF link via SMS when the employee has a phone number on file.',
        emailToggle: 'Send shift report by email on clock-out',
        emailHelp: 'Sends a PDF link via email when the employee has an email address on file.',
        deliveryNotConfigured: '{channel} delivery is not configured for this environment. The toggle can be saved, but reports will not be sent until delivery is set up.',
        saveDelivery: 'Save delivery settings',
        pooledHeading: 'Pooled Tips',
        pooledIntro: 'When enabled, tips and gratuity are shared by clock session (see the pooled tip report) and Stripe pays equal shares when the work period ends — or via Pay pooled tips on an ended Work Period Detail. Sale-time per-employee tip transfers are skipped while this is on. Requires Tip Routing Mode = Platform application fee. Turn off only after unsettled periods are paid. Closeout Summary is unchanged.',
        pooledToggle: 'Pooled Tips',
        pooledHelp: 'Tips and gratuity are shared among employees with the User role who were clocked in when each sale happened. Admin-only and Manager-only PINs do not receive a share, even if they clock in or ring the sale. A PIN that also has the User role still shares. If no User-role employee was clocked in, that tip stays on the platform. Clocking out freezes that person’s share. Settlement runs when the work period ends; use Pay pooled tips on ended periods to retry. Tips already paid at sale time (before pooling was on) are excluded from the pool.',
        savePooled: 'Save pooled tips',
        payoutSmsHeading: 'Tip payout text',
        payoutSmsIntro: 'When enabled, an employee receives one text after a payout lands on their own Stripe account. Realtime tips do not send a text for each sale.',
        payoutSmsToggle: 'Text the employee when a payout is paid to their Stripe account',
        payoutSmsHelp: 'The text uses the store POS language. It says the amount was paid to Stripe and should reach their bank account within 2 business days. It is not sent when the payout goes to the designated manager, and it is not sent again for the same work period.',
        savePayoutSms: 'Save payout text',
        notificationsHeading: 'Customer notification defaults',
        notificationsIntro: 'Merchant-wide defaults for Quick Serve and automatic order-ready notifications. Stations can override these in POS Advanced Settings; use reset to clear all station overrides.',
        quickServeToggle: 'Enable Quick Serve Flow by default',
        quickServeHelp: 'When enabled, new stations inherit pay-first Quick Serve unless they override it. Batch (Bar) mode stations never use Quick Serve.',
        autoSmsToggle: 'Auto-send SMS when order is ready',
        autoSmsHelp: 'Sends an SMS automatically when KDS marks the order complete, if the tab has a phone number.',
        autoEmailToggle: 'Auto-send email when order is ready',
        autoEmailHelp: 'Sends an email automatically when KDS marks the order complete, if the tab has an email address.',
        defaultMessageLabel: 'Default order-ready message',
        defaultMessageHelp: 'Used for automatic SMS and email when a station has not set its own message.',
        saveNotifications: 'Save notification defaults',
        resetStations: 'Reset all station overrides',
        workPeriodHeading: 'Work period maintenance',
        workPeriodIntro: 'Reconcile ended work periods to clock out any users who are still marked active after their period has ended. Open work periods are not affected.',
        workPeriodHelp: 'Reconcile does not send shift reports automatically.',
        reconcile: 'Reconcile ended work periods',
        reconcileTitle: 'Reconcile Ended Work Periods',
        reconcileBody: 'This will clock out any users who are still marked active in work periods that have already ended, setting their clock-out time to that period’s end time.',
        reconcileHelp: 'Open work periods will not be affected. Users who already clocked out will not be changed.',
        reconciling: 'Reconciling…',
        resetTitle: 'Reset Station Notification Overrides',
        resetBody: 'This clears Quick Serve and auto-notification overrides on every station for this merchant. Stations will inherit these merchant defaults instead.',
        resetHelp: 'Station-specific order-ready messages will also be cleared.',
        resetting: 'Resetting…',
        resetConfirm: 'Reset all stations',
    },
    productEdit: {
        details: 'Product Details',
        productAlt: 'Product',
        change: 'Change',
        addImage: 'Add Image',
        name: 'Product Name',
        price: 'Price (In $)',
        cardFee: 'Card Fee Options',
        sku: 'SKU',
        internalOnly: 'Internal item only',
        internalInherited: 'This item inherits Internal item only from its category. Move it to another category to sync it with online stores.',
        internalHelp: 'Keep this on POS and BistroAdmin only. It will not sync to connected online stores or other sales channels.',
        taxRate: 'Tax Rate %',
        stripeTax: 'Stripe tax category',
        inheritDefault: 'Inherit default ({code})',
        food: 'Food ({code})',
        alcohol: 'Alcohol ({code})',
        merchandise: 'Merchandise ({code})',
        custom: 'Custom ({code})',
        description: 'Product description',
        saveDetails: 'Save Product Details',
        addVariations: 'Add Variations',
        variation: 'Variation',
        priceShort: 'Price',
        stock: 'Stock',
        onHand: 'On hand',
        addAnotherVariation: 'Add another Variation',
        addOptions: 'Add Options',
        option: 'Option',
        fromCategory: 'From category',
        fromCategoryTitle: 'Applied from category template',
        trackStock: 'Track stock',
        on: 'On',
        off: 'Off',
        remove: 'Remove',
        addAnotherOption: 'Add another Option',
        manageInventory: 'Manage Inventory',
        totalStock: 'Total stock (sum of variations):',
        variationStockHelp: 'Edit stock on each variation row. Parent inventory is not used while variations exist.',
        availableStock: 'Available Stock',
        saveInventory: 'Save Inventory',
    },
    stripe: {
        heading: 'Stripe Tip Payouts',
        connected: 'Connected',
        pending: 'Pending Onboarding',
        restricted: 'Restricted',
        disabled: 'Disabled',
        notConnected: 'Not Connected',
        linkedExisting: 'Linked existing account',
        platformCreated: 'Platform-created account',
        enterAccountId: 'Enter a Stripe account ID to link.',
        acctPrefix: "Stripe account IDs must start with 'acct_'.",
        disabledHelp: 'Tip payouts are disabled in Store Settings. Enable a payout routing mode before sending setup links or linking employee Stripe accounts.',
        chooseHow: 'Choose how to connect this employee for tip payouts:',
        createNew: 'Create New',
        linkExisting: 'Link Existing',
        sendOnboard: 'Send onboarding link to employee to set up a new Stripe account:',
        sendTo: 'Send to {dest}',
        noEmail: 'No email address',
        noPhone: 'No phone number',
        emailLink: 'Email Link',
        textLink: 'Text Link',
        addContact: 'Add email or phone number to send onboarding link.',
        linkExistingHelp: 'Link an existing Stripe connected account already on this platform.',
        linkAccount: 'Link Stripe Account',
        disabledOnboard: 'Tip payouts are disabled in Store Settings, so onboarding links are unavailable.',
        resend: 'Resend onboarding link:',
        email: 'Email',
        text: 'Text',
        refresh: 'Refresh',
        removeConfirm: 'Remove this Stripe account? The employee will need to be set up again to receive tip payouts.',
        removeAccount: 'Remove Stripe Account',
        incomplete: 'Stripe onboarding is incomplete. The employee must finish setup to receive tips.',
        autoPayout: 'Auto-payout tips:',
        enabled: 'Enabled',
        disabledBtn: 'Disabled',
        viewDashboard: 'View Stripe Dashboard',
        disconnect: 'Disconnect',
        restrictedHelp: 'Stripe account has restrictions. The user needs to update their info on Stripe.',
        fixOnStripe: 'Fix on Stripe',
    },
    toast: {
        exportedJson: 'Exported {products} products and {categories} categories (JSON)',
        exportedExcel: 'Exported {products} products and {categories} categories (Excel)',
        invalidFile: 'Invalid file: {errors}',
        parseJson: 'Could not parse file. Please select a valid JSON export file.',
        parseExcel: 'Could not parse Excel file: {message}',
        importStarting: 'Starting import...',
        catsCreated: '{count} categories created',
        catsExisted: '{count} categories already existed',
        prodsCreated: '{count} products created',
        varsCreated: '{count} variations created',
        optsCreated: '{count} options created',
        imagesFailed: '{count} images could not be transferred',
        importIssues: 'Import completed with issues: {summary}. {errors} error(s).',
        importComplete: 'Import complete! {summary}',
        importFailed: 'Import failed: {message}',
        noExportData: 'No data to export for this date range.',
        reportDownloaded: 'Sales report downloaded ({format}).',
        exportFailed: 'Failed to export sales report.',
        addEmail: 'Add an email address on the employee profile to send reports.',
        addPhone: 'Add a phone number on the employee profile to send reports.',
        reportSentEmail: 'Shift report sent to {dest}',
        reportSentPhone: 'Shift report sent to {dest}',
        reportFailed: 'Failed to send shift report.',
        photoFailed: 'Could not use that photo. Try again with a smaller image.',
    },
    payoutActions: {
        payOutTips: 'Pay out Tips',
        paying: 'Paying…',
        markPaid: 'Mark as Paid (Manual)',
        markingPaid: 'Marking as Paid...',
        markPaidSkip: 'Mark as Paid (Skip)',
        confirmPooled: 'Confirm pooled payout',
        payPooled: 'Pay pooled share',
        payingPooled: 'Paying pooled share...',
        retryFailed: 'Retry Failed Transfers',
        retryingFailed: 'Retrying Failed Transfers...',
        processing: 'Processing...',
        reclaimPlatform: 'Reclaiming to Platform...',
        reclaimTransfer: 'Reclaiming & Transferring...',
        tryNow: 'Try Now',
        trying: 'Trying...',
        emailSetup: 'Email Setup Link',
        textSetup: 'Text Setup Link',
        pendingTransfers: 'Some transfers are still pending for this work period.',
        platformLiquidity: 'Platform tip liquidity',
        loadingBalances: 'Loading platform balances…',
        available: 'Available',
        pending: 'Pending',
        openObligations: 'Open obligations',
        netExposure: 'Net exposure',
        netPosition: 'Net position',
        held: 'Held',
        pooledShareStatus: 'Pooled share status',
        poolShare: 'Pool share',
        payableNow: 'Payable now',
        availableTips: 'Available Tips & Gratuity',
        availablePayout: 'Available for Payout',
        paidToManager: 'Tips and gratuity paid to manager',
        tipRoutingMode: 'Tip routing mode',
        designatedRecipient: 'Designated tip recipient',
        tipsOverview: 'Tips overview',
        payoutSuccessful: 'Payout Successful',
        payoutId: 'Payout ID',
        payoutAmount: 'Payout amount',
        payoutMethod: 'Payout method',
    },
    customerScreen: {
        note: 'Note:',
        noteBody: 'Images, URLs, and videos saved here are available for the customer-facing display. Stations pick which of these assets to show.',
        websiteUrl: 'Website URL',
        websiteName: 'Website name',
        saveUrl: 'Save URL',
        url: 'URL',
        deleteUrl: 'Delete URL?',
        deleteUrlNamed: 'Delete “{name}”? This cannot be undone.',
        deleteUrlBody: 'Delete this URL? This cannot be undone.',
        imageName: 'Image name',
        saveImage: 'Save image',
        deleteImage: 'Delete image?',
        deleteImageNamed: 'Delete “{name}”? This cannot be undone.',
        deleteImageBody: 'Delete this image? This cannot be undone.',
        videoName: 'Video name',
        saveVideo: 'Save video',
        deleteVideo: 'Delete video?',
        deleteVideoNamed: 'Delete “{name}”? This cannot be undone.',
        deleteVideoBody: 'Delete this video? This cannot be undone.',
        images: 'Images',
        imagesIntro: 'Images available for the customer display.',
        replaceImage: 'Replace image',
        chooseImage: 'Choose image',
        editImageName: 'Edit image name',
        websites: 'Websites',
        websitesIntro: 'Website URLs available for the customer display.',
        videos: 'Videos',
        videosIntro: 'Videos available for the customer display.',
        replaceVideo: 'Replace video',
        chooseVideo: 'Choose video',
        editVideoName: 'Edit video name',
        editUrl: 'Edit URL',
        urls: 'URLs',
        urlsIntro: 'Web pages available for the customer display.',
        editWebsite: 'Edit website',
        replacePoster: 'Replace poster',
        choosePoster: 'Choose poster',
        poster: 'Poster',
        mp4Only: 'MP4 files only.',
    },
    layouts: {
        title: 'Layouts',
        venuesHeader: 'Venues & layouts',
        venuesIntro: 'Floor-plans available to stations.',
        newVenue: 'New Venue',
        noVenues: 'No venues yet. Create one to get started — each venue can hold multiple floor-plan layouts that POS stations can switch into Layout View Mode.',
        stationHeader: 'Station layout mode',
        stationIntro: 'Toggle layout view per station.',
        noStations: 'No stations configured yet.',
        layoutOn: 'Layout Mode ON',
        layoutOff: 'Layout Mode OFF',
        venueOption: '— Venue —',
        layoutOption: '— Layout —',
        note: 'Note:',
        noteBody: 'When Layout Mode is ON, that station opens into the selected floor-plan layout instead of the standard product grid. Operators can also toggle this on the device.',
        inactive: 'inactive',
        showLayouts: 'Show layouts',
        noLayouts: 'No layouts yet.',
        noLayoutsForVenue: 'No active layouts for this venue yet. Create one under Venues & layouts.',
        layoutAssigned: 'Layout assigned',
        pickVenueLayout: 'Pick a venue and a layout before enabling Layout Mode.',
        layoutLoading: 'Layout assignment is still loading. Try again in a moment.',
        layoutSaveFailed: 'Station was updated, but saving the layout assignment failed. Try again.',
        saveLayoutBinding: 'Save layout',
        newLayout: 'New layout',
        deactivate: 'Deactivate',
        editVenue: 'Edit Venue',
        description: 'Description',
        eventVenueId: 'Event Venue Id (optional soft-link)',
        eventVenuePlaceholder: 'Leave blank if not linking to a Rebelity event venue',
        editLayout: 'Edit Layout',
        newLayoutTitle: 'New Layout',
        nameRequired: 'Name *',
        importFromEventVenue: 'Import from Event Venue',
        importFromEventVenueHelp: 'Copy a Box Office seating layout into a new POS floor plan (visual only — not ticket sync).',
        importIntro: 'Creates a new POS layout from the linked Box Office seating layer. This is a one-time visual copy. Ticket ObjectIds are not used as POS table ids. Station bindings are not changed.',
        importSeatingLayer: 'Seating layer',
        importLayoutName: 'New layout name',
        importDefault: 'default',
        importNoSeatings: 'No active seating layers found for this Event Venue Id.',
        importPreview: 'Preview',
        importPreviewing: 'Previewing…',
        importPreviewFailed: 'Preview failed. Existing POS layouts were not changed.',
        importEmptyMap: 'Nothing mappable was found. Commit is blocked so layouts are not wiped.',
        importCreate: 'Create layout',
        importCommitting: 'Importing…',
        importCommitFailed: 'Import failed. Existing POS layouts were not changed.',
        importMapped: 'Mapped',
        importSkipped: 'Skipped',
        importConverter: 'Converter',
        importSkipReason: 'Skipped {otype} (not supported on POS)',
    },
    integrations: {
        shopify: 'Shopify',
        shopifyIntro: 'Sync on-hand inventory with your online store. Internal item only categories and products are never included.',
        shopifyIntegration: 'Shopify Integration',
        syncOn: 'Sync on',
        syncPaused: 'Sync paused',
        connectedDomain: 'Connected · {domain}',
        location: 'Location',
        mappedSkus: 'Mapped SKUs',
        lastReconcile: 'Last reconcile',
        openConflicts: 'Open conflicts',
        failedJobs: 'Failed sync jobs',
        lastCatalog: 'Last catalog sync',
        shopifyLocation: 'Shopify location',
        selectLocation: 'Select a location',
        skuMatch: 'SKU match',
        matched: 'Matched',
        unmatched: 'Unmatched',
        unmatchedCollapsed: '{count} Bistro items are hidden. Expand to link them manually.',
        excluded: 'Excluded (internal only)',
        linkHelp: 'Link a Bistro item to an unlinked Shopify variant when SKUs do not match. Linking does not copy quantity.',
        conflicts: 'Inventory conflicts',
        initialFill: 'Initial fill',
        fillHelp: 'Copy on-hand quantity once, then keep both systems in sync from sales and edits. If both sell, the decrements are merged. An explicit set uses the later edit; if those times match, the lower quantity wins.',
        fillOnlineToBistro: 'Online store → Bistro (recommended)',
        fillBistroToOnline: 'Bistro → online store',
        fillMatchOnly: 'Match only — do not copy quantities yet',
        enableSync: 'Enable inventory sync',
        copyOnlineToBistro: 'Copy online store → Bistro',
        copyBistroToOnline: 'Copy Bistro → online store',
        pauseSync: 'Pause sync',
        catalog: 'Catalog (name, price, image)',
        catalogHelp: 'Creates unmatched products in either direction, then copies name, price, and image for linked items. Import catalog and Copy catalog online store → Bistro create Bistro products from Shopify (no prior links required). Copy catalog Bistro → online store creates Shopify products from unmatched Bistro SKUs. Variation and option rows sync name and price; images apply to the parent product.',
        importCatalog: 'Import catalog from Shopify',
        importHelp: 'Creates Bistro products from active Shopify products that have SKUs, or links those SKUs if they already exist in Bistro. Each product goes into a Bistro category named after its Shopify product type (created if missing; blank types use the fallback below). Already-linked products are re-categorized the same way. Inventory tracking is turned on for imported items, including qty 0. On-hand available quantities from the selected Shopify location are copied into Bistro. New categories are added to the default POS menu. This does not turn continuous inventory sync on.',
        importScope: 'Import scope',
        importScopeAll: 'All locations (whole catalog)',
        importScopeLocation: 'Selected location',
        importScopeHelp: 'All imports every active Shopify product with SKUs. Choosing a location imports only variants stocked at that store (inventory level present; quantity may be 0).',
        importScopeSummary: 'Scope: {scope}',
        importSummary: '{shopify} Shopify products · will create {create} · {variations} variations · link {link} · skip {skip}',
        importCategory: 'Fallback Bistro category (when Shopify product type is blank)',
        importCategoryDefault: 'Shopify (create if needed)',
        importCategoryCreate: 'No category yet. Blank product types will use a Shopify category.',
        importSimple: 'Create product',
        importVariations: 'Create product + {count} variations',
        importLink: 'Link {count} existing SKU(s)',
        importNow: 'Import catalog',
        currencyTitle: 'Catalog currency',
        currencySummary: 'Shopify shop: {shop} · Bistro account: {account}',
        currencyUnknown: 'unknown',
        fxRate: 'Bistro currency rate',
        fxRatePlaceholder: 'e.g. 1.27',
        fxRateHelp: 'How many {account} equal 1 {shop}. Import multiplies Shopify prices by this rate; export divides.',
        fxRateSave: 'Save rate',
        fxRateSaved: 'Bistro currency rate saved.',
        fxRateInvalid: 'Enter a rate greater than zero.',
        fxRateSaveFailed: 'Unable to save the Bistro currency rate.',
        fxRateRequired: 'Enter and save a Bistro currency rate before importing or copying catalog prices.',
        fxCurrencyUnknown: 'Shop currency is not detected yet. Open import preview or reconnect Shopify before copying prices.',
        fxNotRequired: 'No conversion needed — currencies match.',
        disconnectShopify: 'Disconnect Shopify',
        connectShopify: 'Connect Shopify',
        connecting: 'Connecting…',
        helpAria: 'How to connect Shopify and import the catalog',
        helpHint: 'Need help? Click the ? for simple connect and import steps.',
        helpTitle: 'Connect Shopify & import catalog',
        helpClose: 'Close help',
        helpConnectTitle: 'Connect your store',
        helpConnect1: 'In Shopify, go to Settings → Apps and sales channels → Develop apps and create a custom app.',
        helpConnect2: 'Turn on Admin API access for products, inventory, and locations (read and write where offered). Do not add webhook scopes.',
        helpConnect3: 'Copy the Allowed redirection URL below and paste it into the Shopify app. Then install the app.',
        helpConnect4: 'Paste the Client ID, Client secret, and store domain (your-store.myshopify.com).',
        helpConnect5: 'Click Save credentials, then Connect Shopify.',
        helpConnect6: 'After you return here, pick the Shopify location that holds your stock.',
        helpImportTitle: 'Import the catalog',
        helpImport1: 'Choose a Shopify location that holds your stock. The fallback category is only used when a Shopify product has no product type.',
        helpImport2: 'Click Import catalog. Active Shopify products with SKUs are created or linked in Bistro by product type (categories are created as needed). Already-linked items are re-categorized. Available quantities are copied and inventory tracking is turned on.',
        helpImport3: 'Imported products and new categories are added to the default POS menu (usually ALL) so they appear on the register.',
        helpImport4: 'When you want quantities to stay in sync ongoing, click Enable inventory sync. To create Shopify products from unmatched Bistro items, use Copy catalog Bistro → online store.',
        helpTipsTitle: 'Remember',
        helpTip1: 'Every product needs a SKU.',
        helpTip2: 'Drafts and items without a SKU are skipped.',
        helpTip3: 'Import copies on-hand stock from the selected location and enables tracking; it does not turn continuous inventory sync on.',
        helpTip4: 'SKUs already in Bistro are linked and re-categorized by Shopify product type, not duplicated.',
        check: 'Check',
        checkIntro: 'Embedded payroll for this location. Connect creates a Check company, then the authorized signer completes Check Onboard (bank, EIN, and filing authorization).',
        checkIntegration: 'Check Integration',
        connectCheck: 'Connect Check',
        employees: 'Employees',
        disconnectConfirm: 'Disconnect Shopify? Inventory will stop syncing. Saved Client ID and secret are kept.',
    },
};

export default en;
